import { all, call, put } from 'redux-saga/effects';
import { Api } from '../../lib/api';
import { getTeamCells } from '../../redux';
function* handleGetTeamCells({ payload }) {
    const { teamId, resolution } = payload;
    try {
        const params = {
            resolution,
            page: 1,
            limit: 4000,
        };
        const response = (yield call(Api.getTeamCells, teamId, params));
        if (response.data.data.total_pages > 1) {
            const subsequentResponses = (yield all(Array
                .from({ length: response.data.data.total_pages - 1 }, (_undefined, index) => index + 2)
                .map((page) => call(Api.getTeamCells, teamId, { ...params, page }))));
            subsequentResponses.forEach((subsequentResponse) => {
                response.data.data.boundary.features.push(...subsequentResponse.data.data.boundary.features);
            });
        }
        yield put(getTeamCells.success(response.data));
    }
    catch (error) {
        yield put(getTeamCells.failure(error));
    }
}
export default handleGetTeamCells;
